"use client";

import { HOTLINE, socialIcons } from "./utils/constants";
import useCMS from "@/utils/hooks/useCMS";
import SendUsAMessageForm from "./components/SendUsAMessageForm";

function ContactUsPage() {
  const { cmsData } = useCMS("VARIABLES");

  const list_hotline =
    HOTLINE?.map((item: any, i: number) => {
      return (
        <div
          key={`list-${i}`}
          className={`${Math.floor(i / 2) % 2 === 0 ? "bg-white" : "bg-surface-subtle"} px-5 py-6`}
        >
          <p className="text-sm font-semibold text-slate-700">
            {item.office || ""} {i}
          </p>
          <p className="text-sm text-slate-700">{item.hotline || ""}</p>
          <p className="text-sm text-slate-700">{item.mobile || ""}</p>
        </div>
      );
    }) || [];

  return (
    <div className="h-full min-h-[500px] w-full bg-surface-subtle py-4">
      {/* SEND US A MESSAGE */}
      <div className={`container mx-auto px-4 py-6`}>
        <h1 className="py-2 pl-2 text-3xl font-bold  text-primary-base">Send Us A Message</h1>
        <div className="mt-5 grid grid-cols-1 bg-white lg:grid-cols-5">
          <div className="col-span-3 flex flex-col items-center">
            <div className="flex flex-col gap-y-4 p-5 text-xs sm:text-sm">
              <div className="pr-0 text-justify text-dark-3 sm:pr-8">
                Our commitment to delivering top-quality service is reflected in our eagerness to
                hear from you. We welcome your feedback, whether you have a news tip, a question
                about our content, or a general inquiry. If you&apos;d like to get in touch, please
                don&apos;t hesitate to use our convenient online contact form to send us an email.
              </div>
              <SendUsAMessageForm />
            </div>
          </div>
          <div className="col-span-2 h-full">
            <iframe
              src={cmsData?.MAP_LINK_EMBED}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
              width={0}
              height={0}
              className="flex h-full min-h-[300px] w-full items-center justify-center overflow-hidden"
            ></iframe>
          </div>
        </div>
      </div>

      {/* CONTACT US */}
      <div className="container mx-auto px-4 pb-6">
        <h1 className="py-2 pl-2 text-3xl font-bold  text-primary-base">Contact Us</h1>
        <div className="mt-5 space-y-3 bg-white pt-3">
          <div className="grid grid-cols-1 sm:grid-cols-2">{list_hotline}</div>
        </div>
      </div>

      {/* SOCIAL MEDIA */}
      <div className="container mx-auto my-6 grid place-items-center gap-6 p-4 text-center md:p-0">
        <h3 className="text-xl font-semibold text-dark-4">
          Follow us on our Social Media Accounts
        </h3>
        {socialIcons?.length > 0 && (
          <div className="flex gap-4 md:gap-6">
            {socialIcons?.map((icon) => (
              <img
                key={icon}
                src={`/images/icons/${icon}`}
                alt=""
                width={56}
                height={56}
                className="h-[40px] w-[40px] md:h-[56px] md:w-[56px]"
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default ContactUsPage;
